"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
class AttackBuilder {
    constructor(attack) {
        this.attack = attack;
    }
    end() {
        return this.attack;
    }
    param(...params) {
        this.attack.params.push(...params);
        return this;
    }
    FR(n) {
        this.attack.FR = n;
        return this;
    }
    limit(limit) {
        this.attack.limit = limit;
        return this;
    }
    base(base) {
        this.attack.base = base;
        return this;
    }
    rate(n) {
        this.attack.rate = n;
        return this;
    }
    completed(p) {
        this.attack.completedProcessor = p;
        return this;
    }
    shouldComputeCri(isAdd = true) {
        if (!isAdd)
            return this;
        this.attack.params.push(index_1.AttackParams.SHOULD_COMPUTE_CRI);
        return this;
    }
    conduction(isAdd = true) {
        if (!isAdd)
            return this;
        this.attack.params.push(index_1.AttackParams.CONDUCTION);
        return this;
    }
    indirect(isAdd = true) {
        if (!isAdd)
            return this;
        this.attack.params.push(index_1.AttackParams.INDIRECT);
        return this;
    }
    real(isAdd = true) {
        if (!isAdd)
            return this;
        this.attack.params.push(index_1.AttackParams.REAL);
        return this;
    }
    critical(isAdd = true) {
        if (!isAdd)
            return this;
        this.attack.params.push(index_1.AttackParams.CRITICAL);
        return this;
    }
    normalAttack(isAdd = true) {
        if (!isAdd)
            return this;
        this.attack.params.push(index_1.AttackParams.SINGLE);
        this.attack.params.push(index_1.AttackParams.NORMAL_ATTACK);
        return this;
    }
    single(isAdd = true) {
        if (!isAdd)
            return this;
        this.attack.params.push(index_1.AttackParams.SINGLE);
        return this;
    }
    group(isAdd = true) {
        if (!isAdd)
            return this;
        this.attack.params.push(index_1.AttackParams.GROUP);
        return this;
    }
    ignoreSource(isAdd = true) {
        if (!isAdd)
            return this;
        this.attack.params.push(index_1.AttackParams.IGNORE_SOURCE);
        return this;
    }
    noShare(isAdd = true) {
        if (!isAdd)
            return this;
        this.attack.params.push(index_1.AttackParams.NO_SHARE);
        return this;
    }
    noTargetEquipment(isAdd = true) {
        if (!isAdd)
            return this;
        this.attack.params.push(index_1.AttackParams.NO_TARGET_EQUIPMENT);
        return this;
    }
    noEargetPassive(isAdd = true) {
        if (!isAdd)
            return this;
        this.attack.params.push(index_1.AttackParams.NO_TARGET_PASSIVE);
        return this;
    }
    noSourceEquipment(isAdd = true) {
        if (!isAdd)
            return this;
        this.attack.params.push(index_1.AttackParams.NO_SOURCE_EQUIPMENT);
        return this;
    }
    noSourcePassive(isAdd = true) {
        if (!isAdd)
            return this;
        this.attack.params.push(index_1.AttackParams.NO_SOURCE_PASSIVE);
        return this;
    }
}
exports.AttackBuilder = AttackBuilder;
class Attack {
    constructor(targetId, sourceId) {
        this.params = [];
        this.targetId = targetId;
        this.sourceId = sourceId;
        this.base = index_1.BattleProperties.ATK;
        this.rate = 1;
        this.FR = 0.01;
        this.params = [];
    }
    hasParam(p) {
        return this.params.includes(p);
    }
    addParam(p) {
        this.params.push(p);
    }
    static build(targetId, sourceId) {
        return new AttackBuilder(new Attack(targetId, sourceId));
    }
}
exports.default = Attack;
